
export default {
  name: 'VsIntersect',
  abstract: true,
  props: {
    threshold: {
      type: [Number, Array],
      default: () => [0, 0.2]
    },
    root: {
      type: Object,
      default: null
    },
    rootMargin: {
      type: String,
      default: '0px 0px 0px 0px'
    }
  },
  beforeMount() {
    const options = {
      threshold: this.threshold,
      root: this.root,
      rootMargin: this.rootMargin
    }

    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0]
      this.$emit('change', entry, this.observer)

      if (!entry.isIntersecting)
        this.$emit('leave', entry, this.observer)
      else
        this.$emit('enter', entry, this.observer)
    }, options)
  },
  mounted() {
    this.$nextTick(() => {
      const slots = this.$slots.default

      if (slots && slots.length)
        this.observer.observe(slots[0].elm)
    })
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
  render() {
    const slots = this.$slots.default
    return slots && slots.length ? slots[0] : null
  }
}
